import { HashRouter, useRoutes, useSearchParams } from "react-router-dom";
import "./App.css";
import { PrivateAuth } from "./Routes/PrivateRoutes";
import { PublicRoutes } from "./Routes/PublicRoutes";
import { SnackbarProvider } from "./Context/SnackbarContext";
import { useEffect, useState } from "react";
import { getLocalStorageItem } from "./Utils/Index";
// import UseSocket from "./Hooks/UseSocket";
import { getBrand } from "./ApiService/Apis/Items/Item";
import { BrandProvider } from "./Context/BrandContext";

function App() {
  const [Routing, setRouting] = useState([
    ...PublicRoutes(),
    ...PrivateAuth(),
  ]);

  const RouteConfig = () => useRoutes(Routing);

  let Role = getLocalStorageItem("userDetail")?.role;

  if (getLocalStorageItem("userDetail") == null) {
    Role = "customer";
  }


 
  console.log("ROLE VALUE:", Role);

  const FetchBrandDetails = () => {
    const restaurantId =
      getLocalStorageItem("userDetail")?.restaurantId ||
      getLocalStorageItem("restaurantId");

    if (!restaurantId) {
      console.log("Restaurant ID not found. Skipping branding API.");
      return;
    }

    getBrand(restaurantId)
      .then((response) => {
        if (response.status && response.data) {
          console.log(response);
        }
      })
      .catch(console.error);
  };

  useEffect(() => {
    if (getLocalStorageItem("access_token")) {
      FetchBrandDetails();

      let data = [...PrivateAuth()];
      if (getLocalStorageItem("role") !== "customer") {
        data[0].children = data[0]?.children.filter(
          (i) => i.name !== "customer" || i.name === "*" || i.name === "resturant"
        );
      } else {
        data[0].children = data[0]?.children.filter(
          (i) => i.name === "customer" || i.name === "*" || i.name === "resturant"
        );
      }
      console.log("abcd",
        data[0].children.map((r) => ({
          path: r.path,
          name: r.name,
        }))
      );

      setRouting([...PublicRoutes(), ...data]);
    } else {
      setRouting([...PublicRoutes(), ...PrivateAuth()]);
    }
    console.log("role :=", getLocalStorageItem("role"));
    console.log("userDetail :=", getLocalStorageItem("userDetail"));
    // eslint-disable-next-line
  }, []);

  return (
    <SnackbarProvider>
      <BrandProvider>
        <div className="bg-dynmaicBg">
          <HashRouter>
            <RouteConfig />
          </HashRouter>
        </div>
      </BrandProvider>
    </SnackbarProvider>
  );
}

export default App;